/**
 * Created by Administrador on 10/11/2016.
 */
(function(){
    'use strict';

    var legendAircraft = {
        templateUrl: 'app/components/seatMap/legend.html',
        controller: legendAircraftController,
        controllerAs: 'vm',
        bindings:{
            legendData: '=',
            nameLegend: '=',
            legendIndex: '=',
            onUpdateLegend: '&',
            onDeleteLegend: '&'
        }
    }

    angular
        .module('completeAir')
        .component('legendAircraft', legendAircraft);

    legendAircraftController.$inject = ['$element'];

    function legendAircraftController($element){

        var vm = this;
        var elemJQLegend = $element.find("div.cabin-legend");

        vm.$onInit = function(){
            vm.legend = vm.legendData;
        }

        vm.$postLink = function(){

            var $dragResize = elemJQLegend.draggable({
                containment: "#seatMapContentMain",
                grid: [1, 1]
            }).resizable();
            $dragResize.on( "resizestop", function( event, ui ) {
                vm.legend.width = ui.size.width;
                vm.legend.height = ui.size.height;
                vm.onUpdateLegend({$event: {value: vm.legendIndex}}, {$event: {value: vm.legend}})
            });
            $dragResize.on( "dragstop", function( event, ui ) {
                vm.legend.left = ui.position.left;
                vm.legend.top = ui.position.top;
                vm.onUpdateLegend({$event: {value: vm.legendIndex}}, {$event: {value: vm.legend}});
            });
        }

        vm.removeCabinLegend = function(){

            vm.onDeleteLegend({legend: vm.legendData, legendIndex: vm.legendIndex});
        }
    }

})();
